import { render, staticRenderFns } from "./ProfileDelete.vue?vue&type=template&id=65607550&"
import script from "./ProfileDelete.vue?vue&type=script&lang=js&"
export * from "./ProfileDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports